import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, OnDestroy, Renderer2 } from '@angular/core';

import { AbstractControl, AsyncValidatorFn, FormGroup, UntypedFormBuilder, ValidationErrors, Validators } from '@angular/forms';
import { Promociones, IPromocionErrRequest, IPromocionErrResponse } from '@p-p-portafolio/interfaces/promociones';
import { SwalService } from '@shared/utils/swal.service';
import { PromocionesService } from '@p-p-portafolio/services/promociones.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';

import { UserService } from '@pages/user/services/user.service';
import { InjectableService } from '@shared/utils/injectable.service';
import { CampoTablaWhereService } from '@shared/services/campo-tabla-where.service';
import { HelpersService } from '@shared/helpers/helpers.service';
import { Observable, of, Subscription } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { SharedDataService } from '@shared/utils/shared-data.service';
import { Location } from '@angular/common';
import { EmpresasService } from '@p-parametria/mantenimiento/abc-empresas/services/empresas.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AbcEmpresasCustomizablesComponent } from '@p-parametria/mantenimiento/abc-empresas/components/abc-empresas-customizables/abc-empresas-customizables.component';

@Component({
  selector: 'app_basepromociones-form',
  templateUrl: './promociones-form.component.html',
  styleUrls: ['./promociones-form.component.css']
})
export class PromocionesFormComponent implements OnInit, OnDestroy {
  receivedData: any = {};
  sPromo: string;
  public model: any;

  private _user: string = JSON.parse(sessionStorage.getItem('user'));
  public empresas: any[] = [];
  public monedas: any[] = [];
  public sucursales: any[] = [];
  private functions: any[] = [];
  private claseCarteras: any[] = [];
  public tipoCarteras: any[] = [];
  private productos: any[] = [];
  form: FormGroup;
  private subscriptions: Subscription = new Subscription();

  //#region Booleanos
  public loading: boolean;
  public formPrincipal: boolean = true;
  public formFunction: boolean;
  public selectEmpresa: boolean;
  public selectMoneda: boolean;
  //#endregion

  constructor(
    private _fb: UntypedFormBuilder,
    private _swalService: SwalService,
    private _ctwServices: CampoTablaWhereService,
    private _promocionesServices: PromocionesService,
    private empresasService: EmpresasService,
    public dialog: MatDialog,
    private _location: Location,
    private _userServices: UserService,
    private _injectServices: InjectableService,
    private sharedDataService: SharedDataService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private _snackBar: MatSnackBar,
    private renderer: Renderer2,
    private el: ElementRef,
    private _helpers: HelpersService
  ) {
    this.form = this._fb.group({
      sPromocion: [
        '',
        {
          validators: [Validators.required],
          asyncValidators: [this.singleSpromocion()],
          updateOn: 'blur'
        }
      ],
      descripcion: ['', Validators.required],
      claseCart: ['', Validators.required],
      plazoMin: ['', Validators.required],
      plazoMax: ['', Validators.required],
      sEmpresa: ['', Validators.required],
      sSucursal: [''],
      sFechaI: ['', Validators.required],
      sFechaF: ['', Validators.required],
      moneda: ['', Validators.required],
      sCartera: ['', Validators.required],
      producto: ['', Validators.required],
      user: this._user
    });

  }

  ngOnInit(): void {
    // Cargar todos los servicios necesarios
    this.loadInitialData();

    // Primero cargar desde sessionStorage si hay datos guardados
    const savedPromocion = sessionStorage.getItem('selectedPromocion');
    if (savedPromocion) {
      try {
        const promocionData = JSON.parse(savedPromocion);
        // Actualizar el servicio con los datos guardados para que otros componentes los vean
        this.sharedDataService.updateData(promocionData);
        this.cargarDatosPromocion(promocionData);
      } catch (error) {
        console.error('Error al cargar promoción desde sessionStorage:', error);
        sessionStorage.removeItem('selectedPromocion');
      }
    }

    // Suscribirse a servicios de inyección
    this.setupInjections();

    // Luego suscribirse al servicio para recibir actualizaciones
    const sharedDataSub = this.sharedDataService.currentData$.subscribe((res) => {
      if (res) {
        this.cargarDatosPromocion(res);
        // Guardar en sessionStorage para persistencia
        sessionStorage.setItem('selectedPromocion', JSON.stringify(res));
        this.updateFunctionsRoutes();
      } else {
        // Solo deshabilitar si realmente no hay datos (no solo si es null inicial)
        if (!savedPromocion) {
          this.form.controls['sSucursal'].disable();
        }
      }
    });
    this.subscriptions.add(sharedDataSub);
  }

  ngOnDestroy(): void {
    // Limpiar todas las suscripciones al destruir el componente
    this.subscriptions.unsubscribe();
  }

  private loadInitialData(): void {
    // Cargar todos los datos iniciales necesarios
    this.readClaseCartera();
    this.readEmpresas();
    this.readMonedas();
    this.readTipoCartera();
    this.readProductos();
  }

  private setupInjections(): void {
    // Suscribirse a servicios de inyección
    const empresasSub = this._injectServices.disparadorEmpresa.subscribe((res) => {
      this.form.patchValue({ sEmpresa: res.model.data });
      this.readSucursales(res.model.data);
      if (res.model.success) this.changeBoolean('form');
    });
    this.subscriptions.add(empresasSub);

    const monedasSub = this._injectServices.disparadorMoneda.subscribe((res) => {
      this.form.patchValue({ moneda: res.model.data });
      if (res.model.success) this.changeBoolean('form');
    });
    this.subscriptions.add(monedasSub);
  }

  private updateFunctionsRoutes(): void {
    // Actualizar las rutas de las funciones con los valores actuales del formulario
    const promocion = this.form.controls['sPromocion'].value || '';
    const empresa = this.form.controls['sEmpresa'].value || '';
    
    this.functions = [
      {
        name: 'Capitales',
        route: `/CredisystemSite/portafolio/promociones/funciones/capitales/${promocion}`
      },
      {
        name: 'Plazos',
        route: `/CredisystemSite/portafolio/promociones/funciones/plazos/${promocion}`
      },
      {
        name: 'Ciclos',
        route: `/CredisystemSite/portafolio/promociones/funciones/ciclos/${promocion}`
      },
      {
        name: 'Contabilidad',
        route: `/CredisystemSite/portafolio/promociones/funciones/contabilidad/${promocion}/${empresa}`
      },
      {
        name: 'Customizables',
        route: '',
        action: () => this.abrirCustomizables()
      },
      {
        name: 'Definiciones',
        route: `/CredisystemSite/portafolio/promociones/funciones/definiciones/${promocion}`
      },
      {
        name: 'Estatus Legal',
        route: `/CredisystemSite/portafolio/promociones/funciones/estatus-legal/${promocion}`
      },
      {
        name: 'Simulador',
        route: `/CredisystemSite/portafolio/promociones/funciones/simulador/${promocion}`
      }
    ];
  }

  close() {
    // Limpiar sessionStorage al cerrar el formulario
    sessionStorage.removeItem('selectedPromocion');
    this._location.back();
    console.log('close');
  }


  readSucursales(empresa: string, sucursal?: string) {
    if (empresa) {
      this._ctwServices.sucursales(empresa).subscribe({
        next: (res) => {
          if (res && res.data) {
            this.sucursales = res.data;
            this.form.controls['sSucursal'].enable();
            this.cdr.detectChanges();

            if (sucursal) {
              this.form.patchValue({ sSucursal: sucursal });
            }
          } else {
            this.sucursales = [];
            this.form.controls['sSucursal'].disable();
          }
        },
        error: (err) => {
          console.error('Error al cargar sucursales:', err);
          this.sucursales = [];
          this.form.controls['sSucursal'].disable();
          this._swalService.error('Error al cargar las sucursales');
        }
      });
    } else {
      this.sucursales = [];
      this.form.controls['sSucursal'].disable();
    }
  }

  changeBoolean(change: string) {
    console.log(change, 'change');
    switch (change) {
      case 'form':
        this.selectEmpresa = false;
        this.selectMoneda = false;
        this.formFunction = false;
        this.formPrincipal = true;
        break;
      case 'function':
        this.selectEmpresa = false;
        this.selectMoneda = false;
        this.formPrincipal = false;
        this.formFunction = true;
        break;
      case 'empresa':
        this.formPrincipal = false;
        this.formFunction = false;
        this.selectMoneda = false;
        this.selectEmpresa = true;
        break;
      case 'moneda':
        this.formPrincipal = false;
        this.formFunction = false;
        this.selectEmpresa = false;
        this.selectMoneda = true;
        break;
    }
  }

  //#region Getters

  readClaseCartera() {
    const user = JSON.parse(sessionStorage.getItem('user') || '""');
    this._promocionesServices.getClaseCartera(user).subscribe({
      next: (res) => {
        if (res && res.data) {
          this.claseCarteras = res.data;
          this.cdr.detectChanges();
        } else {
          console.warn('readClaseCartera: No se recibieron datos del servicio');
          this.claseCarteras = [];
        }
      },
      error: (err) => {
        console.error('Error al cargar clase de cartera:', err);
        this.claseCarteras = [];
        this._swalService.error('Error al cargar las clases de cartera');
      }
    });
  }

  readEmpresas() {
    this._ctwServices.empresas().subscribe({
      next: (res) => {
        if (res && res.data) {
          this.empresas = res.data;
          this.empresas.forEach((element) => {
            if (element.sEmpresa) {
              element.sEmpresa = element.sEmpresa.replace(/\s+/g, '');
            }
          });
          this.cdr.detectChanges();
        } else {
          console.warn('readEmpresas: No se recibieron datos del servicio');
          this.empresas = [];
        }
      },
      error: (err) => {
        console.error('Error al cargar empresas:', err);
        this.empresas = [];
        this._swalService.error('Error al cargar las empresas');
      }
    });
  }

  readTipoCartera() {
    this._promocionesServices.getCnsltTpCartera().subscribe({
      next: (res) => {
        if (res && res.data) {
          this.tipoCarteras = res.data;
          this.cdr.detectChanges();
        } else {
          console.warn('readTipoCartera: No se recibieron datos del servicio');
          this.tipoCarteras = [];
        }
      },
      error: (err) => {
        console.error('Error al cargar tipo de cartera:', err);
        this.tipoCarteras = [];
        this._swalService.error('Error al cargar los tipos de cartera');
      }
    });
  }

  readProductos() {
    this._promocionesServices.getGastos().subscribe({
      next: (res) => {
        if (res && res.data) {
          this.productos = res.data;
          this.cdr.detectChanges();
        } else {
          console.warn('readProductos: No se recibieron datos del servicio');
          this.productos = [];
        }
      },
      error: (err) => {
        console.error('Error al cargar productos:', err);
        this.productos = [];
        this._swalService.error('Error al cargar los productos');
      }
    });
  }

  readMonedas() {
    this._ctwServices.monedas().subscribe({
      next: (res) => {
        if (res && res.data) {
          this.monedas = res.data;
          this.cdr.detectChanges();
        } else {
          console.warn('readMonedas: No se recibieron datos del servicio');
          this.monedas = [];
        }
      },
      error: (err) => {
        console.error('Error al cargar monedas:', err);
        this.monedas = [];
        this._swalService.error('Error al cargar las monedas');
      }
    });
  }
  //#endregion


  private cargarDatosPromocion(res: any): void {
    let fechaI = '';
    let fechaF = '';
    
    // Verificar si las fechas vienen como números julianos o como strings
    if (res.sFechaI) {
      if (typeof res.sFechaI === 'number') {
        // Si es número, es juliano - convertir a dd/MM/yyyy y luego a YYYY-MM-DD
        fechaI = moment(this.convertirJulianaAFechaString(res.sFechaI), 'DD/MM/YYYY').format('YYYY-MM-DD');
      } else if (typeof res.sFechaI === 'string') {
        // Si es string, puede estar en formato dd/MM/yyyy o YYYY-MM-DD
        if (res.sFechaI.includes('/')) {
          fechaI = moment(res.sFechaI, 'DD/MM/YYYY').format('YYYY-MM-DD');
        } else {
          fechaI = res.sFechaI; // Ya está en formato YYYY-MM-DD
        }
      }
    }
    
    if (res.sFechaF) {
      if (typeof res.sFechaF === 'number') {
        // Si es número, es juliano - convertir a dd/MM/yyyy y luego a YYYY-MM-DD
        fechaF = moment(this.convertirJulianaAFechaString(res.sFechaF), 'DD/MM/YYYY').format('YYYY-MM-DD');
      } else if (typeof res.sFechaF === 'string') {
        // Si es string, puede estar en formato dd/MM/yyyy o YYYY-MM-DD
        if (res.sFechaF.includes('/')) {
          fechaF = moment(res.sFechaF, 'DD/MM/YYYY').format('YYYY-MM-DD');
        } else {
          fechaF = res.sFechaF; // Ya está en formato YYYY-MM-DD
        }
      }
    }
    
    const setModel = {
      sPromocion: res.sPromocion,
      descripcion: res.descripcion,
      claseCart: res.claseCart,
      plazoMin: res.plazoMin,
      plazoMax: res.plazoMax,
      sEmpresa: res.sEmpresa,
      sSucursal: res.sSucursal,
      sFechaI: fechaI,
      sFechaF: fechaF,
      moneda: res.moneda,
      sCartera: res.sCartera,
      producto: res.producto,
      user: this._user
    };
    
    this.model = setModel;
    this.form.patchValue(setModel);
    
    // Verificar que los campos se actualicen correctamente
    if (fechaI) {
      this.form.get('sFechaI')?.setValue(fechaI);
    }
    if (fechaF) {
      this.form.get('sFechaF')?.setValue(fechaF);
    }
    if (this.model) {
      this.readSucursales(this.form.controls['sEmpresa'].value, res.sSucursal);
      this.form.controls['sPromocion'].disable();
      this.form.controls['claseCart'].disable();
      this.updateFunctionsRoutes();
    }
  }

  private convertirFechaAJuliana(fecha: string): number {
    if (!fecha) return 0;
    
    // Si la fecha viene en formato YYYY-MM-DD (del input date)
    if (fecha.includes('-')) {
      const partes = fecha.split('-');
      const year = parseInt(partes[0]);
      const month = parseInt(partes[1]);
      const day = parseInt(partes[2]);
      return this._helpers.convertGregorianasToJulianas(day, month, year);
    }
    
    // Si la fecha viene en formato dd/MM/yyyy
    if (fecha.includes('/')) {
      const partes = fecha.split('/');
      const day = parseInt(partes[0]);
      const month = parseInt(partes[1]);
      const year = parseInt(partes[2]);
      return this._helpers.convertGregorianasToJulianas(day, month, year);
    }
    
    return 0;
  }

  private convertirJulianaAFechaString(fechaJuliana: number): string {
    if (!fechaJuliana || fechaJuliana === 0) return '';
    return this._helpers.convertJulianasToGregorianas(fechaJuliana);
  }

  private mapearFormularioAPayload(que: number = 1): IPromocionErrRequest {
    const formValue = this.form.value;
    return {
      que: que,
      clave: formValue.sPromocion,
      descripcion: formValue.descripcion,
      plazoMin: formValue.plazoMin,
      plazoMax: formValue.plazoMax,
      empresa: formValue.sEmpresa,
      vigDesde: this.convertirFechaAJuliana(formValue.sFechaI),
      vigHasta: this.convertirFechaAJuliana(formValue.sFechaF),
      moneda: formValue.moneda,
      tipoCartera: formValue.sCartera,
      tipoCredito: formValue.producto,
      claseCart: formValue.claseCart,
      sSucursal: formValue.sSucursal || '',
      sUsuario: this._user
    };
  }

  create(model: Promociones) {
    if (this.form.valid) {
      this.loading = true;
      const payload: IPromocionErrRequest = this.mapearFormularioAPayload();
      
      this._promocionesServices.createPromocionErr(payload).subscribe({
        next: (res) => {
          this.loading = false;
          // Verificar si la operación fue exitosa
          // Éxito si: success = true O error = "0" O error = 0
          const errorValue = res.data && res.data[0] && res.data[0].error;
          const isSuccess = res.success || errorValue === "0" || errorValue === 0;
          
          if (isSuccess) {
            this._snackBar.open('Promoción creada exitosamente', 'Cerrar', { duration: 3000 });
            // Limpiar sessionStorage al crear exitosamente
            sessionStorage.removeItem('selectedPromocion');
            this.router.navigate(['/CredisystemSite/portafolio/promociones']);
          } else {
            const errorMsg = errorValue ? 
              `Error al crear la promoción: ${errorValue}` : 
              'Error al crear la promoción';
            this._snackBar.open(errorMsg, 'Cerrar', { duration: 3000 });
          }
        },
        error: (error) => {
          this.loading = false;
          console.error('Error al crear promoción:', error);
          this._snackBar.open('Error al crear la promoción', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  update() {
    this.form.controls['sPromocion'].enable();
    this.form.controls['claseCart'].enable();
    
    if (this.form.valid) {
      this.loading = true;
      const payload: IPromocionErrRequest = this.mapearFormularioAPayload(2);
      
      this._promocionesServices.createPromocionErr(payload).subscribe({
        next: (res) => {
          this.loading = false;
          
          // Verificar si la operación fue exitosa
          // Éxito si: success = true O error = "0" O error = 0
          const errorValue = res.data && res.data[0] && res.data[0].error;
          const isSuccess = res.success || errorValue === "0" || errorValue === 0;
          
          if (isSuccess) {
            this._snackBar.open('Promoción actualizada exitosamente', 'Cerrar', { duration: 3000 });
            // this._dialogRef.close();
          } else {
            const errorMsg = errorValue ? 
              `Error al actualizar la promoción: ${errorValue}` : 
              'Error al actualizar la promoción';
            this._snackBar.open(errorMsg, 'Cerrar', { duration: 3000 });
          }
        },
        error: (error) => {
          this.loading = false;
          console.error('Error al actualizar promoción:', error);
          this._snackBar.open('Error al actualizar la promoción', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  //#region Get Fb
  formValue(value: string) {
    return this.form.get(value);
  }
  //#endregion

  //#region AsyncValidation
  singleSpromocion(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      // Si está en modo edición (model existe) ⇒ válido
      if (this.model) {
        return of(null); // ✔️ campo válido
      }

      return this._promocionesServices.readOne(control.value).pipe(
        tap(() => {
          // efecto secundario: asegurarse de quitar la clase, luego según resultado la añade
          const input = this.el.nativeElement.querySelector('#sPromocion');
          this.renderer.removeClass(input, 'is-invalid');
        }),
        map((res) => {
          const input = this.el.nativeElement.querySelector('#sPromocion');

          // 1 → la promoción no existe  ⇒  VÁLIDA
          if (res.exito === 1) {
            this.renderer.addClass(input, 'is-invalid'); // aura roja
            this._snackBar.open('Promoción inválida o ya existente', 'cerrar', { duration: 5000 });
            return { singleSpromocion: true }; // ← objeto de error
          }

          // distinto de 1 → libre  ⇒  INVÁLIDA
          return null; // ← sin errores
        })
      );
    };
  }

  //#endregion
  //#region Funciones
  abrirCustomizables() {
    const dialogRef = this.dialog.open(AbcEmpresasCustomizablesComponent, {
      width: '60%',
      height: '80%',
      disableClose: true,
      data: {
        sClave: this.form.controls['sPromocion'].value,
        sTabla: 'Promociones',
        sNombre: this.form.controls['descripcion'].value
      }
    });

    const dialogSub = dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // Aquí se puede agregar lógica adicional si es necesario
      }
    });
    this.subscriptions.add(dialogSub);
  }
  toLink(fun: any) {
    if (fun.action) {
      fun.action();
      return;
    } else {
      this.router.navigate([fun.route]);
    }
  }

  //#endregion
}
